import React from 'react';
import PropTypes from 'prop-types';
import BookingAmendForm from '../BookingAmendForm';
import TransactionPaymentLinkContainer from 'components/transaction/TransactionPaymentLinkContainer';
import TransactionPaymentMethodsContainer from 'components/transaction/TransactionPaymentMethodsContainer';

const BookingPhaseContainer = (props) => {
    const {
        data,
        form,
        id,
        loading,
        phase,
        prices,
        transactionId,
        dispatchLoaderOff,
        dispatchLoaderOn,
        dispatchMessage,
        setPhase,
    } = props;

    const categoryId = data.product_info.category_id;

    switch (phase) {
        case 'payment-link':
            return (
                <TransactionPaymentLinkContainer
                    bookingId={ id }
                    dispatchLoaderOff={ dispatchLoaderOff }
                    dispatchLoaderOn={ dispatchLoaderOn }
                    dispatchMessage={ dispatchMessage }
                    loading={ loading }
                    prices={ prices }
                    setPhase={ setPhase }
                    transactionId={ transactionId }
                />
            );
        case 'payments':
            return (
                <TransactionPaymentMethodsContainer
                    dispatchLoaderOff={ dispatchLoaderOff }
                    dispatchLoaderOn={ dispatchLoaderOn }
                    loading={ loading }
                    goToPrevious={ () => {
                        setPhase('payments');
                    } }
                    onSelectedQuote={ () => {
                        setPhase('payment-link');
                    } }
                    transactionId={ transactionId }
                />);
        case 'payment-required':
        case 'payment-not-required':
        case 'price-check-error':
        default:
            return (
                <BookingAmendForm
                    categoryId={ categoryId }
                    data={ data }
                    form={ form }
                    loading={ loading }
                    prices={ prices }
                />
            );
    }
};

BookingPhaseContainer.propTypes = {
    data: PropTypes.shape({
        product_info: PropTypes.shape({
            category_id: PropTypes.number.isRequired,
        }),
    }),
    dispatchLoaderOff: PropTypes.func.isRequired,
    dispatchLoaderOn: PropTypes.func.isRequired,
    dispatchMessage: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    phase: PropTypes.string,
    prices: PropTypes.shape({
        price: PropTypes.number,
    }),
    setPhase: PropTypes.func.isRequired,
    transactionId: PropTypes.number,
};

export default BookingPhaseContainer;



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/phase/BookingPhaseContainer.js